var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "c-option",
      class: {
        "is-selected": _vm.option.isSelected === true,
        "is-standard": _vm.option.isStandard === true,
        "is-multiple": _vm.option.isMultiple === true
      },
      attrs: {
        "aria-labelledby": _vm.optionTitle,
        "aria-describedby": _vm.optionDescription,
        tabindex: "0"
      },
      on: {
        click: function($event) {
          return _vm.selectOption(_vm.option.id)
        },
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.selectOption(_vm.option.id)
        }
      }
    },
    [
      _c(
        "header",
        { staticClass: "c-option__header" },
        [
          _c("toggle", {
            staticClass: "c-option__toggle",
            attrs: { isSelected: _vm.option.isSelected }
          }),
          _vm._v(" "),
          _c(
            "h3",
            { staticClass: "c-option__title", attrs: { id: _vm.optionTitle } },
            [
              _vm._v("\n      " + _vm._s(_vm.option.name) + " "),
              _vm.option.isStandard === true
                ? _c("span", [_vm._v("(standard)")])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.visiblePrice !== false
            ? _c("p", { staticClass: "c-option__price" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.visiblePrice.toLocaleString("nb-NO")) +
                    ",–\n    "
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-option__content",
          class: {
            "has-thumbnail": _vm.option.thumbnail
          }
        },
        [
          _vm.option.description
            ? _c("div", [
                _vm.option.description
                  ? _c("p", { attrs: { id: _vm.optionDescription } }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.option.description) +
                          "\n      "
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.option.thumbnail
            ? _c(
                "figure",
                { staticClass: "c-option__figure" },
                [
                  _c("ResponsiveImage", {
                    attrs: { id: _vm.option.thumbnail, css: "c-option__image" }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }